<template>
  <div v-if="!success">
    <form class="newsletter-form" action="" method="post" @submit.prevent="submit">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <label for="firstNameInput" class="sr-only">First name:</label>
          <input v-model="formData.firstName" id="firstNameInput" type="text" class="w-full p-4 border border-gray-900 font-sans mb-4 rounded-sm placeholder-gray-600 focus:outline-none focus:shadow-outline" placeholder="First Name"/>
          <p class="-mt-2 mb-2 text-red-700" v-if="errors && errors.firstName">
            <span v-for="error in errors.firstName">{{ error }}</span>
          </p>
        </div>

        <div>
          <label for="lastNameInput" class="sr-only">Last name:</label>
          <input v-model="formData.lastName" id="lastNameInput" type="text" class="w-full p-4 border border-gray-900 font-sans mb-4 rounded-sm placeholder-gray-600 focus:outline-none focus:shadow-outline" placeholder="Last Name"/>
          <p class="-mt-2 mb-2 text-red-700" v-if="errors && errors.lastName">
            <span v-for="error in errors.lastName">{{ error }}</span>
          </p>
        </div>
      </div>

      <div>
        <label for="emailInput" class="sr-only">Email:</label>
        <input v-model="formData.email" id="emailInput" type="text" name="email" class="w-full p-4 border border-gray-900 font-sans mb-4 rounded-sm placeholder-gray-600 focus:outline-none focus:shadow-outline" placeholder="Email">

        <p class="-mt-2 mb-2 text-red-700" v-if="errors && errors.email">
          <span v-for="error in errors.email">{{ error }}</span>
        </p>
      </div>
      <button type="submit" :disabled="submitting" class="font-sans text-sm font-light leading-normal uppercase border border-gray-900 rounded-full px-6 md:px-12 py-2 tracking-widest hover:bg-black hover:text-white transition duration-300 ease-in-out focus:outline-none focus:shadow-outline">Subscribe</button>
    </form>
  </div>
  <div v-else>
    <p class="mb-2 text-green-600 text-lg">Thank you for subscribing. Please check your inbox to verify your subscription.</p>
  </div>
</template>

<script>
import axios from 'axios'
import formSchema from '../validations/newsletterForm'

export default {
  props: {
    companyId: {
      type: String,
      required: true
    },

    listId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      formData: {
        firstName: "",
        lastName: "",
        email: ""
      },
      submitting: false,
      success: false,
      errors: null
    }
  },

  methods: {
    validateData(data) {
      this.errors = null
      try {
        formSchema.parse(data);
        return true
      } catch (error) {
        this.errors = error.flatten().fieldErrors
        return false
      }
    },

    submit () {
      const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`;

      if (!this.validateData(this.formData)) {
        return
      }

      this.submitting = true

      axios.post(url, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Footer signup form',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  first_name: this.formData.firstName,
                  last_name: this.formData.lastName,
                  email: this.formData.email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.listId
              }
            }
          }
        }
      }, { headers: {revision: '2024-02-15', 'content-type': 'application/json'}})
        .then(response => {
          this.success = true
          this.submitting = false
          console.log(response)
        })
        .catch(error => {
          this.submitting = false
          console.log(error)
        })
    }
  },
}
</script>
